import React, {useContext} from 'react';
import {SortableHandle} from 'react-sortable-hoc';
import {LocalizationContext} from '../../contexts';
import './index.scss';

const SortableHandler = SortableHandle(({}) => <div className="listEditor-listItem-head-tool listEditor-listItem-head-tool--sort"><span className='k-icon k-i-arrows-swap'/></div>);

export default function ListItem({data, settings, onRemove, onToggel, itemTitle, itemContent}) {
    const [localization] = useContext(LocalizationContext);
    const isOnlyOne = settings.minSize === settings.maxSize && settings.minSize === 1 && settings.listLength === 1;
    const isOpen = settings.isOpen || isOnlyOne;
    
    return <div dir={localization.labels.dir} className="listEditor-listItem">
        <div className="listEditor-listItem-head">
            <div className="listEditor-listItem-head-title" onClick={() => {onToggel(settings.index)}}>
                {!isOpen && <span className='k-icon k-i-arrow-chevron-left listEditor-listItem-head-title-arrow'/>}
                {isOpen && <span className='k-icon k-i-arrow-chevron-down listEditor-listItem-head-title-arrow'/>}
                {typeof(itemTitle) === "function" ? itemTitle(data, settings) : itemTitle}
            </div>
            <div className="listEditor-listItem-head-tools">
                {settings && settings.canRemove && !('minSize' in settings && 'listLength' in settings && settings.minSize >= settings.listLength) && <div className="listEditor-listItem-head-tool listEditor-listItem-head-tool--remove" onClick={() => {onRemove(settings.index)}}><span className='k-icon k-i-trash'/></div>}
                {settings && settings.isSortable && settings.listLength > 1 && <SortableHandler />}
            </div>
        </div>
        {settings && (isOpen || !settings.removeContentOnClose) && <div className={`listEditor-listItem-content ${isOpen ? "listEditor-listItem-content--open" : "listEditor-listItem-content--close"}`}>
            {typeof(itemContent) === "function" ? itemContent(data, settings) : itemContent}
        </div>}
    </div>;
};